<template>
  <div :class="['product-details-actions', {'product-details-actions--no-price': isQuoteItem}, {'product-details-actions--expired': isExpiredItem}, {'product-details-actions--internal': isInternalItem}]">
    <div v-if="isExpiredItem" class="product-details-actions__expired">
      <oie-base-icon icon="warning"></oie-base-icon>
      <span v-html="tStatic('expiredItemContent')"></span>
    </div>
    <div v-else-if="isQuoteItem" class="product-details-actions__quote">
      <div v-html="tStatic('requestQuoteContent')"></div>
      <div class="product-details-actions__quote-actions">
        <oie-request-quote-slide-in :item-id="clientModel.selectedItem"></oie-request-quote-slide-in>
        <oie-add-to-shopping-list-slide-in :product="clientModel.currentProduct"></oie-add-to-shopping-list-slide-in>
      </div>
    </div>
    <template v-else>
      <div v-if="isInternalItem" v-html="tStatic('internalItemContent')"></div>
      <div class="product-details-actions__top">
        <oie-product-status
          v-if="stockViewModel"
          :status="stockViewModel.cssName"
          :size="mq('to-medium') ? 'medium' : 'large'"
          :text="stockViewModel.displayName"></oie-product-status>

        <oie-notify-me-slide-in
          v-if="enableArticleWatch"
          :article-number="articleNumber"
          :article-name="articleName"></oie-notify-me-slide-in>
      </div>

      <div class="product-details-actions__bottom">
        <oie-product-detail-price
          v-if="priceViewModel && jsonProduct"
          :price-model="priceViewModel"
          :is-product="isProduct"
          :product="jsonProduct">
        </oie-product-detail-price>

        <oie-product-details-add-to-cart v-if="isProduct && priceViewModel" :price-model="priceViewModel">
        </oie-product-details-add-to-cart>
      </div>
    </template>
  </div>
</template>

<script>
import { find } from 'lodash'
import { productStatuses } from '@/variables/product-statuses'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    isProduct: {
      type: Boolean,
      default: true
    },
    stockViewModel: {
      type: Object,
      required: false
    },
    enableArticleWatch: {
      type: Boolean,
      default: false
    },
    articleNumber: {
      type: [String, Number],
      default: ''
    },
    articleName: {
      type: String,
      default: ''
    },
    priceViewModel: {
      type: Object,
      required: false
    },
    jsonProduct: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters('ui', ['useVat']),
    isQuoteItem() {
      const currentItem = find(this.get(this.clientModel, 'currentProduct.items'), item => item.id == this.clientModel.selectedItem)
      return currentItem ? currentItem.publicationStatusCode === productStatuses.noPrice : false
    },
    isExpiredItem() {
      const currentItem = find(this.get(this.clientModel, 'currentProduct.items'), item => item.id == this.clientModel.selectedItem)
      return currentItem ? currentItem.publicationStatusCode === productStatuses.expired : false
    },
    isInternalItem() {
      const currentItem = find(this.get(this.clientModel, 'currentProduct.items'), item => item.id == this.clientModel.selectedItem)
      return currentItem ? currentItem.publicationStatusCode === productStatuses.internal : false
    }
  },
  watch: {
    useVat() {
      this.loadProduct()
    },
    'clientModel.useListPrice'() {
      this.loadProduct()
    }
  },
  mounted() {
    this.loadProduct()
  },
  methods: {
    ...mapActions('commerce', ['getProduct']),
    loadProduct() {
      this.getProduct({ productId: this.priceViewModel.productId, products: [this.jsonProduct] })
    }
  }
}
</script>

<style lang="scss">
.product-details-actions {
  display: flex;
  flex-direction: column;
  gap: measure(half);
  padding: measure(half);
  background-color: color(background-blue-5);
  border: 1px solid color(border-blue-3);

  @include media(medium) {
    padding: measure(full);
  }
}

.product-details-actions--internal {
  background-color: color(superuser-secondary);
  border: 4px solid color(superuser-primary);
}

.product-details-actions--expired {
  background-color: color(background-gray-4);
  border: 1px solid color(border-gray-2);
}

.product-details-actions__expired {
  display: flex;
  align-items: center;
  gap: measure(eighth);
}

.product-details-actions--no-price {
  background-color: color(background-yellow);
  border: 1px solid color(border-yellow);
}

.product-details-actions__quote {
  display: flex;
  justify-content: space-between;
  gap: measure(half);

  @include media(to-small) {
    flex-direction: column;
  }
}

.product-details-actions__quote-actions {
  display: flex;
  gap: measure(eighth);
  align-items: center;

  @include media(to-small) {
    flex-wrap: wrap;
  }
}

.product-details-actions__quote button {
  white-space: nowrap;
}

.product-details-actions__top {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);
}

.product-details-actions__bottom {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);

  @include media(small) {
    flex-direction: row;
    align-items: flex-end;
  }
}
</style>
